export default __webpack_public_path__ + "static/media/linkedin.0a72bdf7.svg";